import { useState } from "react";
import { motion } from "framer-motion";

interface QuestionConcernProps {
  onNext: () => void;
  onBack?: () => void;
  onSelect: (value: string) => void;
  selected: string;
}

const options = [
  { label: "Rimpels & fijne lijntjes", value: "wrinkles", emoji: "🧴" },
  { label: "Verlies van stevigheid", value: "firmness", emoji: "🤲" },
  { label: "Doffe, vermoeide huid", value: "dullness", emoji: "😔" },
  { label: "Alles hierboven", value: "all", emoji: "✨" },
];

const QuestionConcern = ({ onNext, onBack, onSelect, selected }: QuestionConcernProps) => {
  const [justSelected, setJustSelected] = useState<string | null>(null);

  const handleSelect = (value: string) => {
    onSelect(value);
    setJustSelected(value);
    setTimeout(() => onNext(), 800);
  };

  return (
    <div>
      {onBack && (
        <button
          onClick={onBack}
          className="flex items-center gap-2 text-foreground/80 font-sans text-lg md:text-xl mb-5 md:mb-8 hover:text-foreground transition-colors cursor-pointer px-3 py-2 -ml-3 rounded-lg hover:bg-secondary/50"
        >
          <span className="text-xl">←</span> Terug
        </button>
      )}
      <div className="text-center">

      <h2 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-6 md:mb-10 leading-tight">
        Wat wil je het liefst verbeteren?
      </h2>

      <div className="grid gap-3">
        {options.map((opt, i) => (
          <motion.button
            key={opt.value}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.08 * i, duration: 0.25 }}
            onClick={() => handleSelect(opt.value)}
            className={`quiz-option text-left flex items-center gap-4 ${
              selected === opt.value ? "quiz-option-selected" : ""
            }`}
          >
            <span className="text-2xl text-accent flex-shrink-0 w-8 text-center">{opt.emoji}</span>
            <span className="text-foreground font-medium text-lg">{opt.label}</span>
            {selected === opt.value && (
              <motion.span
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="ml-auto text-primary animate-check-pop"
              >
                ✓
              </motion.span>
            )}
          </motion.button>
        ))}
      </div>

      </div>
    </div>
  );
};

export default QuestionConcern;
